import React, { useEffect, useRef } from 'react';

import MessageInput from './composer/message_input';
import { Card } from '@buildoutinc/blueprint-react/ui/Card';
import { Transcript } from './transcript/transcript';
import { useConversationContext } from './conversation_context';

import './styles.scss';

interface Props {
  pinned?: React.ReactNode;
}

// Renders into a Card the surface owns, so each one can put its own chrome above this.
export function Conversation({ pinned }: Props) {
  const {
    attachments, busy, input, messages, recording, restoring, send, sttSupported, visible,
    addAttachments, changeInput, removeAttachment, submit, toggleMic,
  } = useConversationContext();

  const bodyRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    bodyRef.current?.scrollTo({ top: bodyRef.current.scrollHeight });
  }, [messages, busy, visible]);

  return (
    <>
      <Card.Body className="ai-assistant-chat flex-grow-1 overflow-auto" ref={bodyRef}>
        <Transcript messages={messages} restoring={restoring} onSelectStarter={send} />
      </Card.Body>

      {pinned}

      <Card.Footer className="bg-transparent border-top-0 pt-0">
        <MessageInput
          attachments={attachments}
          input={input}
          loading={busy}
          recording={recording}
          sttSupported={sttSupported}
          onAddAttachments={addAttachments}
          onInputChange={changeInput}
          onMicClick={toggleMic}
          onRemoveAttachment={removeAttachment}
          onSubmit={submit}
        />
        <p className="text-muted small text-center mt-2 mb-0">AI-generated content may be inaccurate.</p>
      </Card.Footer>
    </>
  );
}
